export enum EMapUrl {
    Road = "https://mt0.google.com/vt/lyrs=m&hl=vi&x={x}&y={y}&z={z}&s=Ga",
    Satellite = "https://mt0.google.com/vt/lyrs=y&hl=vi&x={x}&y={y}&z={z}&s=Ga"
}
